import React from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import useStyles from "@hooks/useStyles";
import Header from "@components/Main/Shared/Header";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Link from "@material-ui/core/Link";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import Footer from "@components/Main/Shared/Footer";
import Button from "@material-ui/core/Button";

const { SITE_NAME, BRAND_NAME } = process.env;

const Press = () => {
	const classes = useStyles("Terms");

	return (
		<React.Fragment>
			<Header />

			<Box pt={6} pb={10}>
				<Container maxWidth={"md"}>
					<Box pb={10}>
						<Box
							component={"h1"}
							fontSize={32}
							lineHeight={1.5}
							fontWeight={700}
							mb={5}
						>
							Press and media assets
						</Box>

						{/* <Button
							href={`//static.${SITE_NAME}.com/assets/images/misc/press.pdf`}
							variant={"outlined"}
							color={"primary"}
						>
							Download fact sheet
						</Button> */}
					</Box>
				</Container>

				<Container maxWidth={"md"}>
					<Box pb={10}>
						<Box
							component={"h2"}
							fontSize={24}
							lineHeight={1.5}
							fontWeight={700}
							mb={5}
						>
							Leadership headshots
						</Box>

						<Grid container spacing={8}>
							<Grid item xs={12} sm={4}>
								<Box width={"100%"}>
									<Avatar
										variant="rounded"
										alt="Tom Grupa"
										className={classes.teamAvatar}
										src="//static.lessons.com/assets/images/desktop/thumbs/tom_950.jpg"
									/>
									<Box display={"flex"} alignItems={"center"} mt={4} mb={2}>
										<Box fontSize={18} fontWeight={600} mr={2}>
											Tom Grupa
										</Box>
										<Box display={"flex"} alignItems={"center"}>
											<Link
												href={"https://www.linkedin.com/in/tom-grupa/"}
												target={"_blank"}
												style={{ lineHeight: 0 }}
											>
												<LinkedInIcon color={"primary"} />
											</Link>
										</Box>
									</Box>
									<Box mb={2}>Co-founder & Chief Executive Officer</Box>
									<Box fontSize={12} lineHeight={1.6} color={"grey.700"}></Box>
								</Box>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Box width={"100%"}>
									<Avatar
										variant="rounded"
										alt="Tom Grupa"
										className={classes.teamAvatar}
										src="//static.lessons.com/assets/images/desktop/thumbs/paul_950.jpg"
									/>
									<Box display={"flex"} alignItems={"center"} mt={4} mb={2}>
										<Box fontSize={18} fontWeight={600} mr={2}>
											Paul Mazzola
										</Box>
										<Box display={"flex"} alignItems={"center"}>
											<Link
												href={"https://www.linkedin.com/in/pauljmazzolaiii/"}
												target={"_blank"}
												style={{ lineHeight: 0 }}
											>
												<LinkedInIcon color={"primary"} />
											</Link>
										</Box>
									</Box>
									<Box mb={2}>Co-founder & Chief Operations Officer</Box>
									<Box fontSize={12} lineHeight={1.6} color={"grey.700"}></Box>
								</Box>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Box width={"100%"}>
									<Avatar
										variant="rounded"
										alt="Tom Grupa"
										className={classes.teamAvatar}
										src="//static.lessons.com/assets/images/desktop/thumbs/mac_950.jpg"
									/>
									<Box display={"flex"} alignItems={"center"} mt={4} mb={2}>
										<Box fontSize={18} fontWeight={600} mr={2}>
											Mac Lara
										</Box>
										<Box display={"flex"} alignItems={"center"}>
											<Link
												href={"https://www.linkedin.com/in/macariolara/"}
												target={"_blank"}
												style={{ lineHeight: 0 }}
											>
												<LinkedInIcon color={"primary"} />
											</Link>
										</Box>
									</Box>
									<Box mb={2}>Co-founder & Chief Technical Officer</Box>
									<Box fontSize={12} lineHeight={1.6} color={"grey.700"}></Box>
								</Box>
							</Grid>
						</Grid>
					</Box>

					<Box pb={10}>
						<Box
							component={"h2"}
							fontSize={24}
							lineHeight={1.5}
							fontWeight={700}
							mb={5}
						>
							Logos
						</Box>

						<Grid container spacing={8}>
							<Grid item xs={12} sm={4}>
								<Box width={"100%"}>
									<Avatar
										component={"a"}
										href={`//static.${SITE_NAME}.com/assets/images/misc/${SITE_NAME}-logo-500x500.png`}
										variant="rounded"
										className={classes.teamAvatar}
										src={`//static.${SITE_NAME}.com/assets/images/misc/${SITE_NAME}-logo-500x500.png`}
										alt={BRAND_NAME}
									/>
								</Box>
							</Grid>
							<Grid item xs={12} sm={4}>
								<Box width={"100%"}>
									<Avatar
										component={"a"}
										href={`//static.${SITE_NAME}.com/assets/images/misc/${SITE_NAME}-logo-800x300.png`}
										variant="rounded"
										className={classes.teamAvatar}
										src={`//static.${SITE_NAME}.com/assets/images/misc/${SITE_NAME}-logo-800x300.png`}
										alt={BRAND_NAME}
									/>
								</Box>
							</Grid>
						</Grid>
					</Box>
				</Container>
			</Box>

			<Footer />
		</React.Fragment>
	);
};

export default Press;
export const loader = (route) =>
	loadable(() => import("./Press.component"), { ssr: !!route.ssr });
